import GiftFilter from "./gift-filter";
import GiftList from "./gift-list";
import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {useEffect} from "react";
import {setToolsInitialState} from "../../reducers/tools.reducer";
import {setGiftSelectedRowKeys} from "../../reducers/gift.reducer";
import {SORT_LIST_GIFT} from "../../utils/sort-list";
import {useEffectAfterMount} from "../../services/useEffectAfterMount";

const GiftPage = () => {
    const dispatch = useDispatch()
    const defaultSort = SORT_LIST_GIFT?.find(item => item.isDefault)
    const getOrderBy = defaultSort?.key.split('_')
    const {
        currentPage,
        pageSize,
        orderBy,
        sort,
        searchKey,
        filter,
        reload
    } = useSelector(state => state.toolsReducer)
    const queryParams = {
        page: currentPage,
        perPage: pageSize,
        orderBy: !!orderBy ? orderBy : getOrderBy[0],
        orderType: sort,
        search: searchKey,
        filterByStatus: filter['status'] ?? []
    }
    const {
        data: response,
        fetching: getGiftList,
        isLoading
    } = useFetch(API.GIFT_LIST_PAGE, queryParams, {isWithTotalData: true})

    useEffect(() => {
        return () => {
            dispatch(setToolsInitialState())
            dispatch(setGiftSelectedRowKeys([]))
        }
    }, [])

    useEffectAfterMount(() => {
        getGiftList()
    }, [currentPage, pageSize, orderBy, sort, searchKey, filter, reload])

    return (
        <div className={"col px-10"}>
            <GiftFilter/>
            <GiftList datasource={response?.data?.result ?? []} isLoading={isLoading}/>
        </div>
    )
}

export default GiftPage